import { combineReducers, configureStore } from '@reduxjs/toolkit';
import themeSettingSlice from './themeSettingSlice';
import sidebarSlice from './sidebarSlice';
import authReducer from './auth/authSlice';
import userReducer from './user/userSlice'
import companyDetailsReducer from './company/companyDetailsSlice'
import roleReducer from './user/role/roleSlice'
import employeeReducer from './employee/employeeSlice'
import SkillReducer from './skill/skill.Slice'
import departmenReducer from './department/departmentSlice'
import duductionReducer from './deduction/deductionSlice'
import policyReducer from './policy/policySlice'
import policycategoryReducer from './policyCategory/policyCategorySlice'
import designationReducer from './designation/designationSlice'
import holidayReducer from './holiday/holidaySlice'
import rolePermissionReducer from './user/rolePermission/rolePermissionSlice'
import leaveTypeReducer from './attendance/leaveTypes/LeaveTypeSlice'
import leaveRequestReducer from './attendance/leave/leaveSlice'
import punchReducer from './attendance/punch/punchSlice'
import trainingAssignReducer from "./training/trainingSlice";
import calendarReducer from './calendar/calendarSlice'
import resignationReducer from './resignation/resignationSlice';
import terminationReducer from './termination/terminationSlice';
import trainingtypeReducer from './training/trainertype/trainertypeSlice'
import trainerReducer from './training/trainer/trainerSlice';
import performanceGoaltypeReducer from './performance/goaltype/goaltypeSlice'
import performanceGoallistReducer from './performance/goallist/goallistSlice'
import IndicatorGroupReducer from './performance/indicatorgroup/indicatorgroupSlice';
import indicatorReducer from './performance/indicator/indicatorSlice';
import overtimeReducer from './attendance/overtime/overtimeSlice'
import shiftScheduleTypeReducer from './attendance/shiftSchedule/shiftScheduleSlice'
import shiftReducer from './attendance/shift/shiftMasterSlice'
import clientReducer from './projects/client/clientSlice'
import projectReducer from './projects/project/projectSlice'
import taskReducer from './projects/task/taskSlice'
import taskBoardReducer from './projects/taskBoard/taskBoardSlice'
import worklogReducer from './attendance/timeworkSheet/timeworkSheetSlice'
import roleindicatorReducer from './performance/roleindicator/roleindicatorSlice'
import appraisalReducer from './performance/appraisal/appraisalSlice'
import kraReducer from './performance/KRA/kraSlice'
import Appliedappraisal from './performance/appliedappraisal/appliedappraisalSlice';
import achievementReducer from './performance/achievement/achievementSlice'
import commentreducer from './performance/comment/commentSlice'
import personalgoalReducer from './performance/personalgoal/personalgoalSlice'
import promotionReducer from './promotion/promotionSlice'
import goalReducer from './performance/goal/goalSlice'
import MaintenanceReportSlice from './reports/maintenance_report/maintenancereport.Slice'
import branchSliceReducer from './branch/branch.Slice'
import weekoffReducer from './weekoff/weekoff.Slice'
import WorkformhomeSlice from './attendance/workfromrequest/workfromhomeSlice'


import assetCategoryReducer from './asset/assetCategorySlice'
import assetReceiptReducer from './asset/assetReceipt/assetReceiptSlice'
import assetcreationReducer from './asset/asset/assetSlice'
import assetAllocationReducer from './asset/assetAllocation/assetAllocationSlice'
import assetTrackingReducer from './asset/assetTracking/assetTrackingSlice'
import assetRequestReducer from './asset/assetRequest/assetRequestSlice'
import assetMaintenanceReducer from './asset/assetMaintenanceAction/assetMaintenanceSlice'
import ticketCategoryReducer from './tickets/ticketCategorySlice'
import ticketReducer from './tickets/ticket/ticketSlice'
import ticketDetailReducr from './tickets/ticketDetail/ticketDetailSlice'
import payscaleReducer from './payroll/payrollComponent/payscale/payscaleSlice'
import earningReducer from './payroll/payrollComponent/earning/earningSlice'
import deductionReducer from './payroll/payrollComponent/deduction/deductionSlice'
import overtimepayReducer from './payroll/payrollComponent/overtimePayRate/overtimePaySlice'
import salaryStructureReducer from './payroll/payrollStructure/payrollStructure/employeeSalaryStructureSlice'
import salaryTransactionReducer from './payroll/payrollSalary/salaryTransaction/salaryTransactionSlice'
import salaryPayslipReducer from './payroll/payrollSalary/payslip/payslipSlice'
import expensesCategoriesReducer from './payroll/Accounting/expensesCategories/expensesCategoriesSlice'
import budgetRevenueReducer from './payroll/Accounting/budgetRevenues/budgetRevenueSlice'
import budgetExpensesReducer from './payroll/Accounting/budgetExpenses/budgetExpensesSlice'
import budgetReducer from './payroll/Accounting/budgets/budgetsSlice'
import providentFundReducer from './payroll/Accounting/providentFund/providentFundSlice'
import pfPolicyReducer from './payroll/Accounting/providentFund/pfpolicies/pfPolicySlice'
import pfEmployeeMappingReducer from './payroll/Accounting/providentFund/pfEmployee/pfEmployeeSlice'
import pfLoanRequestReducer from './payroll/Accounting/providentFund/pfLoanRequest/pfLoanSlice'
import pfWithdrawlReducer from './payroll/Accounting/providentFund/pfWithdrawal/pfWithdrawalSlice'
import pfDuesReducer from './payroll/Accounting/providentFund/pfDue/pfDueSlice'
import pfLedgerReducer from './payroll/Accounting/providentFund/pfLedger/pfLedgerSlice'
import expenseReducer from './payroll/Accounting/expenses/expenseSlice'
import adminDashboardReducer from './dashboards/admindashboard/adminDashboardSlice'
import employeelogReducer from './employeelog/employeelog.Slice'
import EmployeeNotificationReducer from './notification/employeeNotification/employeeNotificationSlice'
import notificationReducer from './notification/notification/notificationSlice'
import configurationSettingReducer from './user/configurationSetting/configurationSettingsSlice'
import sidebarSearchReducer from './gloabalSearch/sidebarSearchSlice'
import financialYearsReducer from './financialYear/financialYearSlice'

// TDS
import taxReducer from './payroll/TDS/taxes/taxSlice'
import tdsTaxRegimeReducer from './payroll/TDS/tdsTaxRegime/tdsTaxRegimeSlice'
import tdsSurchargeCessReducer from './payroll/TDS/tdsSurchargeCess/tdsSurchargeCessSlice'
import tdsTaxSectionReducer from './payroll/TDS/tdsTaxSection/tdsTaxSectionSlice'
import employeeTDSContributionReducer from './payroll/TDS/employeeTdsContribution/employeeTdsContributionSlice'
import tdsDeclarationReducer from "./payroll/TDS/tdsDelcaration/tdsDeclarationSlice";

// ESIC
import configurationReducer from './payroll/ESIC/Master/Configuration/configurationSlice'
import benefitReducer from './payroll/ESIC/Master/Benefit/BenefitSlice'
import reasonReducer from './payroll/ESIC/Master/Reason/ReasonSlice'
import disablementReducer from './payroll/ESIC/Master/Disablement/DisablementtSlice'
import branchReducer from './payroll/ESIC/Master/Branch/branchSlice'
import MonthlyContributionReducer from './payroll/ESIC/Master/MonthlyContribution/esicMonthlyContributionSlice'
import esicEmployeeReducer from './payroll/ESIC/employeeMapping/employeemappingSlice'

//HR-Dashboard
import hrDashboardReducer from './hr-dashboard/hrDashboardSlice'




const payrollReducer = combineReducers({
  payrollScall: payscaleReducer,
  earning: earningReducer,
  deduction: deductionReducer,
  overtimRate: overtimepayReducer,
  salaryStructure: salaryStructureReducer,
  salaryTransaction: salaryTransactionReducer,
  salaryPayslip: salaryPayslipReducer,
});

const accountReducer = combineReducers({
  expensesCategories: expensesCategoriesReducer,
  budget: budgetReducer,
  budgetRevenue: budgetRevenueReducer,
  budgetExpenses: budgetExpensesReducer,
  taxes: taxReducer,
  expenses: expenseReducer,
});
const TDSReducer = combineReducers({
  tdsTaxRegime: tdsTaxRegimeReducer,
  tdsSurchargeCess: tdsSurchargeCessReducer,
  tdsTaxSection: tdsTaxSectionReducer,
  employeeTDSContribution: employeeTDSContributionReducer,
  tdsDeclaration: tdsDeclarationReducer,
})

const esicReducer = combineReducers({
  configuration: configurationReducer,
  benefit: benefitReducer,
  reason: reasonReducer,
  disablement: disablementReducer,
  branch: branchReducer,
  monthlycontribution: MonthlyContributionReducer,
  esicEmployee: esicEmployeeReducer,
})
const pfReducer = combineReducers({
  employeeContribution: providentFundReducer,
  pfPolicy: pfPolicyReducer,
  pfEmployeeMapping: pfEmployeeMappingReducer,
  pfLoanRequest: pfLoanRequestReducer,
  pfWithdrawl: pfWithdrawlReducer,
  pfDues: pfDuesReducer,
  pfLedger: pfLedgerReducer,
});

const reportsReducer = combineReducers({
  maintenancereport: MaintenanceReportSlice,
})


const trainingReducer = combineReducers({
  training: trainingAssignReducer,
  trainingType: trainingtypeReducer,
  trainer: trainerReducer,
});

const assetReducer = combineReducers({
  assetCategory: assetCategoryReducer,
  newAsset: assetcreationReducer,
  assetReceipt: assetReceiptReducer,
  assetAllocation: assetAllocationReducer,
  assetTracking: assetTrackingReducer,
  assetRequest: assetRequestReducer,
  assetMaintenance: assetMaintenanceReducer,
});

const performanceReducer = combineReducers({
  goaltype: performanceGoaltypeReducer,
  goallist: performanceGoallistReducer,
  indicatorgroup: IndicatorGroupReducer,
  indicator: indicatorReducer,
  roleindicator: roleindicatorReducer,
  appraisal: appraisalReducer,
  kra: kraReducer,
  appliedappraisal: Appliedappraisal,
  achievement: achievementReducer,
  comments: commentreducer,
  personalgoal: personalgoalReducer,
  goal: goalReducer
})

const attendanceReducer = combineReducers({
  leaveTypes: leaveTypeReducer,
  leaveRequests: leaveRequestReducer,
  punch: punchReducer,
  overtime: overtimeReducer,
  shiftSchedule: shiftScheduleTypeReducer,
  shift: shiftReducer,
  worklog: worklogReducer
});

const projectsReducer = combineReducers({
  clients: clientReducer,
  projects: projectReducer,
  task: taskReducer,
  taskBoard: taskBoardReducer,
});
const ticketsReducer = combineReducers({
  ticketCategory: ticketCategoryReducer,
  createTickit: ticketReducer,
  ticketDetail: ticketDetailReducr

});

const dashboardReducer = combineReducers({
  adminDashboard: adminDashboardReducer,
  hrDashboard: hrDashboardReducer
});
const notificationCombineReducer = combineReducers({
  employeeNotification: EmployeeNotificationReducer,
  notification: notificationReducer,

});


const store = configureStore({
  reducer: {
    themeSetting: themeSettingSlice,
    sidebarSlice: sidebarSlice,
    auth: authReducer,
    user: userReducer,
    companyDetails: companyDetailsReducer,
    role: roleReducer,
    rolePermission: rolePermissionReducer,
    employee: employeeReducer,
    department: departmenReducer,
    designation: designationReducer,
    duduction: duductionReducer,
    policy: policyReducer,
    holiday: holidayReducer,
    attendance: attendanceReducer,
    training: trainingReducer,
    calendar: calendarReducer,
    resignation: resignationReducer,
    termination: terminationReducer,
    performance: performanceReducer,
    project: projectsReducer,
    asset: assetReducer,
    ticket: ticketsReducer,
    payroll: payrollReducer,
    promotion: promotionReducer,
    dashboard: dashboardReducer,
    report: reportsReducer,
    skill: SkillReducer,
    accounting: accountReducer,
    configurationSettings: configurationSettingReducer,
    providentFund: pfReducer,
    policycategory: policycategoryReducer,
    branch: branchSliceReducer,
    weekoff: weekoffReducer,
    workfromHome: WorkformhomeSlice,
    employeelog: employeelogReducer,
    notification: notificationCombineReducer,
    sidebarSearch: sidebarSearchReducer,
    financialYears: financialYearsReducer,
    TDS: TDSReducer,
    esic:esicReducer,
    esicEmployee: esicEmployeeReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export default store;
export type RootState = ReturnType<typeof store.getState>;

